import { Col, Row } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorCatch, POST } from 'fennec-ui';
import "react-lightbox-pack/dist/index.css";
import { useAuth } from 'fennec-ui';

import { Tabs } from 'antd';
import Account from '../../../components/Account';
import { useState } from 'react';
import PageLayout from '../../../components/PageLayout';
import { useBreadcrumbs, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext } from '../../../../common/Context';
import CapsuleMenu from '../../../components/CapsuleMenu';

dayjs.locale('ru');

var _ = require('lodash');


export default function Accounts(props) {
	const auth = useAuth();
	const dispatch = useDispatch();

	const meta = useSelector(state => state.meta);

	const user = useSelector(state => state.home.user);
	const role = useSelector(state => state.home.role, () => { });
	const role_by_id = useSelector(state => state.home.role_by_id);
	const role_by_name = useSelector(state => state.home.role_by_name);

	const [akkaunti, setAkkaunti] = useState([]);

	const { ctx } = props;
	useEffect(() => {
		if (ctx) {
			POST(auth, "/api/akkaunti/byowner",
				ctx,
				// {
				// 	// userID
				// 	// organizatorFederatsiyaID
				// 	// organizatorShkolaID
				// 	// organizatorMeropriyatiyaID
				// 	organizatorRegionalnoeOtdelenieID: ctx?.ID
				// 	// meropriyatieID
				// 	// userLockID
				// }, 
				({ data }) => {
					setAkkaunti(data?.sort((a, b) => a?.akkauntType?.enumAccountTypeID - b?.akkauntType?.enumAccountTypeID))
				}, errorCatch)
		}
	}, [ctx]);

	// akkauntTypeID
	// 1	Счет федерации (Основной)
	// 2	Счет пользователя (Основной)
	// 3	Счет регионального отделения (Основной)
	// 4	Счет организатора (Основной)
	// 5	Счет школы (Основной)
	// 6	Счет мероприятия (Основной)
	// 8	Счет федерации (Накопительный)
	// 9	Счет пользователя (Накопительный)
	// 10	Счет регионального отделения (Накопительный)
	// 11	Счет организатора (Накопительный)
	// 12	Счет школы (Накопительный)
	// 13	Счет мероприятия (Накопительный)

	const items = akkaunti?.map((e, i) => ({
		key: i,
		label: (<div>
			<div style={{ fontSize: "12px", color: "grey" }}>
				{(e?.akkauntType?.enumAccountTypeID == 1) && <span>Основной счет</span>}
				{(e?.akkauntType?.enumAccountTypeID == 2) && <span>Накопительный счет</span>}
			</div>
			<div>
				<span>№{e?.nomerAkkaunta}</span>
			</div>
		</div>),
		children: <Account key={i} auth={auth} account={e} />,
	}))

	// ----------------------------------------
	const breadcrumbs = useBreadcrumbs()
	const menuLevelOne = useMenuLevelOneContext()
	const menuLevelTwo = useMenuLevelTwoContext()
	const menuLevelThree = useMenuLevelThreeContext()
	const getLast = (path) => {
		if (!path) return;
		var loc_array = path.split("/")
		var lst = loc_array[loc_array.length - 1]
		if (!lst) return;
		return lst
	}
	const getBase = (path) => {
		if (!path) return;
		var loc_array = path.split("/")
		var lst = loc_array.slice(0, -1)
		return lst.join("/")
	}
	const getLevel = (arr, i) => {
		let p = "/app"
		var count = 0;
		for (let idx = 0; idx < arr.length; idx++) {
			if (count >= i) return p;
			if (!arr[idx]?.context) {
				count++
			}
			p += `/${arr[idx]?.uuid}`
		}
		return p
	}
	// ----------------------------------------

	return (<div className="subcontent">
		<div className={"content"}>
			<PageLayout hideSider={true} >
				<div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", borderRadius: "4px" }}>
					
				{/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}
					
					<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
						<div style={{ padding: "10px" }}>
							
									<Tabs defaultActiveKey="1" items={items} />
								
						</div>
					</div>
				</div>
			</PageLayout>
		</div>
		<div className={"footer"}>
			<CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />

			{/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
			{/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

		</div>
	</div>)
}
